<div class="password-rules">
  <div class="title-password-requirements">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21Z"
        style="fill: var(--color-neutral-950-to-white);" />
      <path
        d="M12 11C11.45 11 11 11.45 11 12V16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16V12C13 11.45 12.55 11 12 11Z"
        style="fill: var(--color-neutral-650-to-white);" />
      <path
        d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
        style="fill: var(--color-neutral-650-to-white);" />
    </svg>
    <p>{{ 'components.passwordRequirements.title' | i18n }}</p>
  </div>

  <div class="requirements">
    <div *ngFor="let item of requirementsList" class="requirement-item" [class.default]="isPristine"
      [class.valid]="!isPristine && item.isValid" [class.invalid]="!isPristine && !item.isValid">

      <div class="icon-container">
        <!-- Ícone círculo preenchido para estado default (pristine) e válido -->
        <svg *ngIf="isPristine || item.isValid" width="6" height="6" viewBox="0 0 16 16" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="8" cy="8" r="8" fill="currentColor" />
        </svg>

        <!-- Ícone X para estado inválido após digitar -->
        <svg *ngIf="!isPristine && !item.isValid" width="11" height="11" viewBox="0 0 16 16" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M10.0999 5.90002L5.8999 10.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M5.8999 5.90002L10.0999 10.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <span>{{ item.text }}</span>
    </div>
  </div>
</div>